import { useEffect, useRef, useState } from 'react'
import { Toast } from '../UI/toast/Toast'

const COPIED_FEEDBACK_MS = 2000

// navigator.clipboard solo existe en contextos seguros (https o localhost) y el
// navegador puede negar el permiso (por ejemplo, dentro de un iframe); en esos
// casos se copia seleccionando el campo como respaldo.
const copyText = async (value, input) => {
  try {
    await navigator.clipboard.writeText(value)
    return
  } catch (error) {
    if (!input) throw error
  }
  input.select()
  if (!document.execCommand('copy')) throw new Error('copy failed')
}

// Copia un texto y deja `copied` con la clave de lo copiado durante unos
// segundos, para que el botón muestre "¡Copiado!".
const useCopy = () => {
  const [copied, setCopied] = useState(null)
  const timer = useRef(null)

  useEffect(() => () => clearTimeout(timer.current), [])

  const copy = async (key, value, input, message) => {
    try {
      await copyText(value, input)
      setCopied(key)
      clearTimeout(timer.current)
      timer.current = setTimeout(() => setCopied(null), COPIED_FEEDBACK_MS)
      Toast.fire({ type: 'success', title: message })
    } catch (error) {
      Toast.fire({ type: 'error', title: 'No pudimos copiarlo. Selecciónalo y cópialo manualmente.' })
    }
  }

  return { copied, copy }
}

export default useCopy
